<template>
    <section>
        <!-- Modal -->
        <div class="modal" id="customer_addresses_modal" data-backdrop="static" role="dialog" aria-labelledby="myModalLabel">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title" id="myModalLabel">Addresses of Customer: {{customerName}}</h4>
                    </div>
                    <div class="modal-body">
                        <div class="row" v-if="!baykedCustomer && (where === 'customers' || where === 'deliveryOrder')">
                            <div class="col-md-12">
                                <div class="btn-group open pull-right">
                                    <div data-toggle="dropdown" v-bind:class="'btn btn-primary btn-xs dropdown-toggle ld-ext-right ' + actionBtnLoadingClass" aria-expanded="true">
                                        Actions
                                        <span class="caret"></span>
                                        <div class="ld ld-ring ld-spin"></div>
                                    </div>
                                    <ul class="dropdown-menu">
                                        <li><a data-toggle="modal" data-target="#add_new_address_modal">Add New Address</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                      <div class="">
                        <a v-on:click="addNewAddress()" v-if="baykedCustomer" class="pull-right" ><i class="fa fa-plus">&nbsp;Add New Address</i></a>
                        <!-- Reseting data on modal  -->
                      </div>
                        <ul class="list-unstyled">
                            <li v-for="address in customerAddresses" v-bind:key="address.id">
                                <address>
                                    <b class="text-danger" v-if="address.deleted">This address is disabled</b><br/>
                                    <a type="radio" v-on:click="selectAddressForNewOrder(address.id)" v-if="where === 'deliveryOrder' && !address.deleted" >SELECT - </a>
                                      <strong>Area: </strong> {{(baykedCustomer) ? address.area : address.areasByAreaId.name}} -
                                        <a v-if="!baykedCustomer" title="Update Address" v-on:click="updateAddress(address.id)"><i class="fa fa-pencil"></i></a>&nbsp;
                                        <a v-if="baykedCustomer" title="Delete Address" v-on:click="deleteDvmCustomerAddress(address.id)"> <i class="fa fa-trash"></i></a>&nbsp;
                                        <a v-if="baykedCustomer" target="_blank" class="MyToolTip" title="View On Map" v-bind:href="'https://www.google.com/maps/place/'+address.latitude+','+address.longitude"><i class="fa fa-map-marker"></i></a>
                                    <a v-if="userRole!=='ROLE_ADMIN' && !address.requestToDisable && !address.deleted" @click="requestToDisable(address.id)"> - <i class="fa fa-trash" title="Request To Disable"></i></a>
                                    <b class="text-danger" v-if="address.requestToDisable && !address.deleted"> - Requested To disabled
                                    <a v-if="userRole==='ROLE_ADMIN' && address.requestToDisable && !address.deleted" @click="toggleAddressStatus(address.id, true)"> - (<i class="fa fa-check" title="Approve"></i></a>
                                    <a v-if="userRole==='ROLE_ADMIN' && address.requestToDisable && !address.deleted" @click="toggleAddressStatus(address.id, false)">|<i class="fa fa-remove" title="Reject"></i>)</a></b>
                                    <br>
                                    {{address.address}}<br>
                                    {{(baykedCustomer) ? address.citiesByCityId.city :address.areasByAreaId.citiesByCityId.city}}<br>
                                    <abbr >Created: </abbr> <i>{{address.created | formatDate}}</i><br/>
                                    <abbr>Modified: <i>{{address.modified | formatDate}}</i></abbr>
                                </address>
                            </li>
                        </ul>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
        <AddNewAddress ref="addNewAddressPopup" from="vcd" v-bind:customerId="customerId" v-bind:customerName="customerName"/>
        <AddNewBebambiCustomerAddress v-if="baykedCustomer" ref="addNewAddress" v-bind:customerId="customerId" v-bind:customerName="customerName"/>
    </section>
</template>

<script>
    /* eslint-disable */
    import AddNewAddress from "@/components/customers/AddNewAddress"
    import {getBaykedCustomerAddresses, deleteBaykedCustomerAddress} from "../../api/customers";
    import AddNewBebambiCustomerAddress from "@/components/customers/AddNewBebambiCustomerAddress.vue";
    export default {
        name: "ViewCustomerAddresses",
        components: {AddNewBebambiCustomerAddress, AddNewAddress},
        props: {
            where:String
        },
        data:function() {
            return {
                customerId: 0,
                customerName: "",
                customerStatus: "",
                actionBtnLoadingClass: "",
                customerAddresses: [],
                userRole:'',
                baykedCustomer: false,
            };
        },
        mounted() {
          this.JQueryOnToolTip();
        },
        methods: {
            updateAddress: function (addressId) {
                this.$refs.addNewAddressPopup.loadForUpdate(addressId);
            },
          addNewAddress () {
            this.$refs.addNewAddress.loadForNewInsertion();
          },
            load: async function (id, name, status, baykedCustomer=false) {
              let loggedInUser = this.$store.state.user;
              if (loggedInUser) {
                this.userRole = loggedInUser.userRolesById[0].role;
              }
              this.customerId = parseInt(id);
              this.customerName = name;
              this.customerStatus = status;
              if(!baykedCustomer){
                await this.loadDvmCustomerData();
              }else{
                await this.loadBaykedCustomerData();
              }
              setTimeout(()=> {
                $("#customer_addresses_modal").modal("show");
                $("#customer_addresses_modal").focus();
              },500);
            },
            loadDvmCustomerData: async function () {
              let params = new URLSearchParams();
              params.append('customer_id', this.customerId);
              await this.$http.post(this.$store.state.mainAppURL + "customers/get_all_customer_addresses", params).then(resp => {
                this.customerAddresses = resp.data;
              });
            },
            loadBaykedCustomerData: async function(){
              let baykedCustomerAddress= await getBaykedCustomerAddresses(this.customerId);
              this.customerAddresses = baykedCustomerAddress.data;
              this.baykedCustomer = true;
            },
            deleteDvmCustomerAddress: async function(address_id){
              Swal.fire({
                title: 'Are you sure?',
                text: "Do you want to delete the address?",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#1ab394',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Delete'
              }).then(async result => {
                if (result.value) {
                  await deleteBaykedCustomerAddress(address_id);
                  await this.loadBaykedCustomerData(this.customerId);
                }
              });
            },
            requestToDisable: function(addressId){
                let self= this;
                Swal({
                    title: 'Are you sure?',
                    text: "Are you sure you want to request admin to disable this address!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#1ab394',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes'
                }).then((result) => {
                    if (result.value) {
                        self.$http.get( self.$store.state.mainAppURL + "customers/request_to_disable_address/"+addressId).then(resp => {
                            Swal.close();
                            if(resp.data){
                                this.customerAddresses = resp.data;
                                swal("SUCCESS!", "Sucessfully Requested", "success");
                            }else{
                                swal("Error!", "Please try again!", "error");
                            }
                        }).catch(ex => {
                            swal("Error!", ex + "\nPlease try again!!", "error");
                        });
                    }
                });
            },
            toggleAddressStatus: function(addressId, deletedAddress) {
                
                let self= this;
                Swal.fire({
                    title: 'Please Wait! We are processing the data.',
                    type: 'info',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    onBeforeOpen: () => {
                        Swal.showLoading();
                    },
                });
                let params= new URLSearchParams();
                params.append('address_id', addressId);
                params.append('deleted', deletedAddress)
                this.$http.post(this.$store.state.mainAppURL + "customers/toggle_customer_address_status", params).then(resp=>{
                    Swal.close();
                    self.customerAddresses= resp.data;
                })
            },
            selectAddressForNewOrder: function (addressId) {
                this.$parent.updateNewAddressOfCustomer(addressId);
                $("#customer_addresses_modal").modal("hide");
            },
            JQueryOnToolTip: function (){
              $(".MyToolTip").tooltip({
                placement:"left"
              });
            },
        }
    }
</script>

<style scoped>
.modal { overflow: auto !important; }
</style>
